import {
  adjustmentSessionIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

const MissingLocationInventorySchema_ = z.object({
  productId: productIdFormat.schema,
  productTitle: z.string(),
  locationName: z.string(),
});

export const MissingLocationInventorySchema: z.ZodType<MissingLocationInventory> =
  MissingLocationInventorySchema_;
export interface MissingLocationInventory extends z.infer<
  typeof MissingLocationInventorySchema_
> {}

const DeletedProductSchema_ = z.object({
  productId: productIdFormat.schema,
  productTitle: z.string(),
});

export const DeletedProductSchema: z.ZodType<DeletedProduct> =
  DeletedProductSchema_;
export interface DeletedProduct extends z.infer<typeof DeletedProductSchema_> {}

export const submitAdjustmentSession = {
  name: "submitAdjustmentSession" as const,
  input: z.object({
    sessionId: adjustmentSessionIdFormat.schema,
    /** If true, create location_inventory records for products that don't exist at the location */
    createMissingLocationInventory: z.boolean().optional(),
    acknowledgeUnDeleteProducts: z.boolean().optional(),
    notes: z.string().optional(),
  }),
  output: z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("ok"), pending: z.boolean().optional() }),
    z.object({
      kind: z.literal("needs-undelete-ack"),
      deletedProducts: z.array(DeletedProductSchema),
    }),
    z.object({
      kind: z.literal("needs-location-ack"),
      missingLocationInventory: z.array(MissingLocationInventorySchema),
    }),
  ]),
};
